module.exports = __webpack_public_path__ + "static/fonts/Robotoblack.bf7b513.ttf";